export enum SecurityCategory{
    Undefined = -1,
    StocksFuture = 80
}